import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { color: string }>(
  {
    root: {
      backgroundColor: ({ color }) => color,
      border: `1px solid ${BackgroundColors.tint3}`,
      display: 'flex',
      height: 82,
      width: 102,
      alignItems: 'center',
      justifyContent: 'center',

      '&$hovered': {
        '&>$container': {
          display: 'flex',
          alignItems: 'center',
        },
      },

      '&> $container': {
        display: 'none',
      },
    },

    hovered: {},

    container: {
      flexDirection: 'column',
      width: '100%',
    },

    text: {
      textAlign: 'center',
    },
  },
  {
    name: 'color-rectangle',
  },
);

export default useStyles;
